module.exports = __webpack_public_path__ + "static/media/gs-battery.917f7977.png";